// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.C5PvdcdMQT8FINvMxYcm {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.WvlyWbMwsOUq6K46p6fk {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f5f7fa;
}
.QMkqk9o7s69Utyo8yxlM {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 48px;
  background: #ffffff;
  border-bottom: 1px solid var(--Color-Border-border-color-light, #E4E7ED);
}
.QMkqk9o7s69Utyo8yxlM .DCpV3PT4eEmg5MI4L6Dn {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
}
.QMkqk9o7s69Utyo8yxlM .DCpV3PT4eEmg5MI4L6Dn .MRjAnZkXKJTucrKOf8uC {
  flex-shrink: 0;
  display: block;
}
.QMkqk9o7s69Utyo8yxlM .DCpV3PT4eEmg5MI4L6Dn .va1kRGVXTu2oZCTktMzh {
  font-family: PingFang SC;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  color: var(--Color-Text-text-color-primary, #1F2227);
  margin: 0;
}
.QMkqk9o7s69Utyo8yxlM .CIReJKT3LkJU6uUEInIr {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 24px;
}
.QMkqk9o7s69Utyo8yxlM .CIReJKT3LkJU6uUEInIr .s5IaQ_7uaDwXcRqZNa3D {
  font-family: PingFang SC;
  font-weight: 500;
  font-style: Medium;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0px;
  color: var(--Color-Text-text-color-primary, #1F2227);
  cursor: pointer;
  transition: color 0.3s ease;
}
.QMkqk9o7s69Utyo8yxlM .CIReJKT3LkJU6uUEInIr .s5IaQ_7uaDwXcRqZNa3D:hover {
  color: #1890ff;
}
.UXqj7w4MmsMKiqSQGIS7 {
  background: #ffffff;
  position: relative;
  padding: 20px;
}
.UXqj7w4MmsMKiqSQGIS7 .sJ_2vsqNflAuwxtP1Hkc {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.UXqj7w4MmsMKiqSQGIS7 .gkngLhCuGvkLOB4_gdwk {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 20px;
  height: 20px;
}
.UXqj7w4MmsMKiqSQGIS7 .gkngLhCuGvkLOB4_gdwk .JkwT8RIYA4OAp7lR0zzT {
  font-family: PingFang SC;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #1F2227;
}
.UXqj7w4MmsMKiqSQGIS7 .gkngLhCuGvkLOB4_gdwk .wSKolf5xRvaNUADSIJpo {
  display: inline-block;
  font-size: 20px;
  color: #1F2227;
  cursor: pointer;
}
.UXqj7w4MmsMKiqSQGIS7 .LqDjBMHFfW3wEVVfv2ET {
  flex: 1;
  padding-top: 10px;
}
.bwd-steps-vertical {
  padding-top: 16px;
}
.bwd-steps-vertical.bwd-steps-dot .bwd-steps-item {
  max-height: none;
  min-height: 56px;
  margin-bottom: 12px;
}
.bwd-steps-vertical.bwd-steps-dot .bwd-steps-item .bwd-steps-item-container .bwd-steps-item-tail {
  top: 16px;
  padding: 12px 0 0;
}
.bwd-steps-vertical.bwd-steps-dot .bwd-steps-item .bwd-steps-item-container .bwd-steps-item-tail:after {
  width: 2px;
  color: #DBDBDB;
}
.bwd-steps-vertical.bwd-steps-dot .bwd-steps-item .bwd-steps-item-container .bwd-steps-item-icon {
  margin-right: 12px;
}
.bwd-steps-vertical.bwd-steps-dot .bwd-steps-item .bwd-steps-item-container .bwd-steps-item-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  padding-right: 0;
}
.bwd-steps-vertical.bwd-steps-dot .bwd-steps-item.bwd-steps-item-active .bwd-steps-item-container .bwd-steps-item-title {
  color: #0073E5;
}
.Cj1IT8j_9vkh3grm2awl {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  box-shadow: 0px 4px 16px 0px #0000001A;
  border-radius: 4px;
  border-left: 1px solid #E4E7ED;
}
.Cj1IT8j_9vkh3grm2awl micro-app,
.Cj1IT8j_9vkh3grm2awl micro-app-body {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.HbwyhQI1fXZgXsTRtXDv {
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CreateApp.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AAEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AAAF;AAGA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,wEAAA;AADF;AAPA;EAWI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AADJ;AAbA;EAiBM,cAAA;EACA,cAAA;AADN;AAjBA;EAsBM,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,oDAAA;EACA,SAAA;AAFN;AA3BA;EAkCI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAJJ;AAjCA;EAwCM,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,oDAAA;EACA,eAAA;EACA,2BAAA;AAJN;AAMM;EACE,cAAA;AAJR;AAWA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;AATF;AAMA;EAMI,aAAA;EACA,sBAAA;EACA,YAAA;AATJ;AACA;EAYI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;AAVJ;AANA;EAmBM,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAVN;AAfA;EA6BM,qBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAXN;AArBA;EAqCI,OAAA;EACA,iBAAA;AAbJ;AAiBA;EAEI,iBAAA;AAhBJ;AAkBI;EAEI,gBAAA;EACA,gBAAA;EACA,mBAAA;AAjBR;AAaI;EAQQ,SAAA;EACA,iBAAA;AAlBZ;AAoBY;EACE,UAAA;EACA,cAAA;AAlBd;AAKI;EAkBQ,kBAAA;AApBZ;AAEI;EAsBQ,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AArBZ;AAyBQ;EAGM,cAAA;AAzBd;AAkCA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EAEA,gBAAA;EACA,sCAAA;EACA,kBAAA;EACA,8BAAA;AAjCF;AAuBA;;EAaI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;AAhCJ;AAoCA;EACE,UAAA;AAlCF","sourcesContent":[".loadingContainer {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.layout {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background: #f5f7fa;\n}\n\n.header {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  height: 48px;\n  background: #ffffff;\n  border-bottom: 1px solid var(--Color-Border-border-color-light, #E4E7ED);\n\n  .headerLeft {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    .logo {\n      flex-shrink: 0;\n      display: block;\n    }\n\n    .title {\n      font-family: PingFang SC;\n      font-weight: 500;\n      font-style: Medium;\n      font-size: 16px;\n      line-height: 24px;\n      letter-spacing: 0px;\n      color: var(--Color-Text-text-color-primary, #1F2227);\n      margin: 0;\n    }\n  }\n\n  .headerRight {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    gap: 24px;\n\n    .menuItem {\n      font-family: PingFang SC;\n      font-weight: 500;\n      font-style: Medium;\n      font-size: 12px;\n      line-height: 20px;\n      letter-spacing: 0px;\n      color: var(--Color-Text-text-color-primary, #1F2227);\n      cursor: pointer;\n      transition: color 0.3s ease;\n\n      &:hover {\n        color: #1890ff;\n      }\n    }\n\n  }\n}\n\n.sider {\n  background: #ffffff;\n  position: relative;\n  padding: 20px;\n\n  .siderContent {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n\n  .siderHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 20px;\n    height: 20px;\n\n    .titleText {\n      font-family: PingFang SC;\n      font-weight: 500;\n      font-style: Medium;\n      font-size: 16px;\n      line-height: 100%;\n      letter-spacing: 0%;\n      color: #1F2227;\n    }\n\n    .collapseButton {\n      display: inline-block;\n      font-size: 20px;;\n      color: #1F2227;\n      cursor: pointer;\n    }\n  }\n\n  .steps {\n    flex: 1;\n    padding-top: 10px;\n  }\n}\n\n:global {\n  .bwd-steps-vertical {\n    padding-top: 16px;\n\n    &.bwd-steps-dot {\n      .bwd-steps-item {\n        max-height: none;\n        min-height: 56px;\n        margin-bottom: 12px;\n\n        .bwd-steps-item-container {\n          .bwd-steps-item-tail {\n            top: 16px;\n            padding: 12px 0 0;\n\n            &:after {\n              width: 2px;\n              color: #DBDBDB;\n            }\n          }\n\n          .bwd-steps-item-icon {\n            margin-right: 12px;\n          }\n\n          .bwd-steps-item-title {\n            font-size: 16px;\n            font-weight: 600;\n            line-height: 1.5;\n            padding-right: 0;\n          }\n        }\n\n        &.bwd-steps-item-active {\n          .bwd-steps-item-container {\n            .bwd-steps-item-title {\n              color: #0073E5;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  // margin: 24px;\n  overflow: hidden;\n  box-shadow: 0px 4px 16px 0px #0000001A;\n  border-radius: 4px;\n  border-left: 1px solid #E4E7ED;\n\n  micro-app, micro-app-body {\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n  }\n}\n\n.footer {\n  padding: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `C5PvdcdMQT8FINvMxYcm`,
	"layout": `WvlyWbMwsOUq6K46p6fk`,
	"header": `QMkqk9o7s69Utyo8yxlM`,
	"headerLeft": `DCpV3PT4eEmg5MI4L6Dn`,
	"logo": `MRjAnZkXKJTucrKOf8uC`,
	"title": `va1kRGVXTu2oZCTktMzh`,
	"headerRight": `CIReJKT3LkJU6uUEInIr`,
	"menuItem": `s5IaQ_7uaDwXcRqZNa3D`,
	"sider": `UXqj7w4MmsMKiqSQGIS7`,
	"siderContent": `sJ_2vsqNflAuwxtP1Hkc`,
	"siderHeader": `gkngLhCuGvkLOB4_gdwk`,
	"titleText": `JkwT8RIYA4OAp7lR0zzT`,
	"collapseButton": `wSKolf5xRvaNUADSIJpo`,
	"steps": `LqDjBMHFfW3wEVVfv2ET`,
	"content": `Cj1IT8j_9vkh3grm2awl`,
	"footer": `HbwyhQI1fXZgXsTRtXDv`
};
export default ___CSS_LOADER_EXPORT___;
